import React from 'react';
import { INVOICES } from '../data';

const H1: React.CSSProperties = { fontSize: 26, fontWeight: 800, margin: '0 0 6px', color: '#0E1A1A' };
const SUB: React.CSSProperties = { margin: 0, fontSize: 14, color: '#66748B', maxWidth: 560 };
const PAGE_HEAD: React.CSSProperties = {
  display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
  gap: 24, marginBottom: 22,
};
const BTN: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 8,
  background: '#0E1A1A', color: '#FFFFFF',
  fontSize: 14, fontWeight: 600, padding: '11px 18px',
  borderRadius: 10, border: 0, cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(14,26,26,.12)',
};
const BTN_OUTLINE: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 6,
  background: '#FFFFFF', color: '#0E1A1A',
  border: '1px solid #E7EAF0', boxShadow: 'none',
  fontSize: 12.5, fontWeight: 600, padding: '8px 12px',
  borderRadius: 8, cursor: 'pointer',
};
const BTN_VELA: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 6,
  background: 'linear-gradient(135deg, #6B46C1 0%, #8B5CF6 100%)',
  color: '#FFFFFF', fontSize: 13, fontWeight: 600,
  padding: '9px 14px', borderRadius: 8, border: 0, cursor: 'pointer',
};
const RUNWAY: React.CSSProperties = {
  display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 20,
};
const STAT: React.CSSProperties = {
  background: '#FFFFFF', border: '1px solid #E7EAF0', borderRadius: 12, padding: '14px 18px',
};
const STAT_LBL: React.CSSProperties = { fontSize: 11.5, color: '#66748B', fontWeight: 600, marginBottom: 6 };
const STAT_V: React.CSSProperties = { fontSize: 22, fontWeight: 800, lineHeight: 1 };
const STAT_SUB: React.CSSProperties = { fontSize: 11.5, color: '#66748B', marginTop: 4 };

const CARD: React.CSSProperties = {
  background: '#FFFFFF', border: '1px solid #E7EAF0', borderRadius: 14,
  padding: 20, marginBottom: 14,
};
const CARD_HEAD: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, gap: 10, flexWrap: 'wrap',
};
const INV_META: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' };
const INV_REF: React.CSSProperties = { fontSize: 15, fontWeight: 700, color: '#0E1A1A' };
const INV_CUST: React.CSSProperties = { fontSize: 13, color: '#66748B' };
const BADGE: React.CSSProperties = {
  fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 999,
  background: '#FEF2F2', color: '#B91C1C', textTransform: 'uppercase', letterSpacing: 0.3,
};
const AMT: React.CSSProperties = { fontSize: 18, fontWeight: 800, color: '#0E1A1A' };
const DRAFT: React.CSSProperties = {
  background: '#FAFBFD', border: '1px solid #E7EAF0', borderRadius: 10,
  padding: '14px 16px', marginBottom: 14,
};
const DRAFT_HEAD: React.CSSProperties = {
  fontSize: 11, fontWeight: 700, color: '#6B46C1',
  textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6,
};
const DRAFT_BODY: React.CSSProperties = {
  fontSize: 13, color: '#0E1A1A', lineHeight: 1.55, whiteSpace: 'pre-line',
};
const ACTIONS: React.CSSProperties = { display: 'flex', gap: 10, flexWrap: 'wrap' };

const chaseDraft = (name: string, invoice: string, amount: number, days: number) =>
  `Hi ${name.split(' ')[0]},\n\nJust a friendly nudge: invoice ${invoice} for $${amount.toLocaleString()} was due ${days} days ago. If it's already on its way, ignore this. Otherwise, you can pay here in one tap:\n\nPay ${invoice}\n\nThanks so much,\nClaire`;

export default function ChaseHub() {
  const overdueInvoices = INVOICES.filter((i) => i.status === 'overdue');
  const overdueTotal = overdueInvoices.reduce((s, i) => s + i.amount, 0);
  const openTotal = INVOICES.filter((i) => i.status !== 'paid' && i.status !== 'draft')
    .reduce((s, i) => s + i.amount, 0);

  return (
    <div>
      <div style={PAGE_HEAD}>
        <div>
          <h1 style={H1}>Chase hub</h1>
          <p style={SUB}>Everything that's owed to you, with Vela drafts ready for the ones you want to send.</p>
        </div>
        <button type="button" style={BTN}>Chase all with Vela</button>
      </div>

      <div style={RUNWAY}>
        <div style={STAT}>
          <div style={STAT_LBL}>Overdue</div>
          <div style={{ ...STAT_V, color: '#B91C1C' }}>${overdueTotal.toLocaleString()}</div>
          <div style={STAT_SUB}>{overdueInvoices.length} invoices</div>
        </div>
        <div style={STAT}>
          <div style={STAT_LBL}>Open total</div>
          <div style={STAT_V}>${openTotal.toLocaleString()}</div>
          <div style={STAT_SUB}>everything unpaid</div>
        </div>
        <div style={STAT}>
          <div style={STAT_LBL}>Cash runway</div>
          <div style={STAT_V}>42 days</div>
          <div style={STAT_SUB}>at current burn</div>
        </div>
        <div style={STAT}>
          <div style={STAT_LBL}>Chases sent, 30d</div>
          <div style={STAT_V}>0</div>
          <div style={STAT_SUB}>recover faster with Vela</div>
        </div>
      </div>

      {overdueInvoices.length === 0 ? (
        <div style={{ ...CARD, textAlign: 'center', padding: 40 }}>
          <h3 style={{ fontSize: 18, margin: '0 0 6px' }}>Nothing to chase.</h3>
          <p style={{ color: '#66748B', margin: 0 }}>Every open invoice is on track.</p>
        </div>
      ) : (
        overdueInvoices.map((inv) => (
          <div key={inv.id} style={CARD}>
            <div style={CARD_HEAD}>
              <div style={INV_META}>
                <span style={INV_REF}>{inv.number}</span>
                <span style={INV_CUST}>{inv.customer}</span>
                <span style={BADGE}>{inv.daysOverdue}d overdue</span>
              </div>
              <span style={AMT}>${inv.amount.toLocaleString()}</span>
            </div>
            <div style={DRAFT}>
              <div style={DRAFT_HEAD}>Vela draft, friendly tone</div>
              <div style={DRAFT_BODY}>{chaseDraft(inv.customer, inv.number, inv.amount, inv.daysOverdue ?? 0)}</div>
            </div>
            <div style={ACTIONS}>
              <button type="button" style={BTN_VELA}>Review &amp; send {'\u203A'}</button>
              <button type="button" style={BTN_OUTLINE}>Change tone</button>
              <button type="button" style={BTN_OUTLINE}>Set up payment plan</button>
              <button type="button" style={BTN_OUTLINE}>Snooze 7 days</button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}